const mutations = {

    ADD_FUNCIONARIO (state, value) {

        state.funcionarios.push(value)

    },
    ALL_TIPO_DOCUMENTO (state, value) {

        state.tipo_documento = value

    },
    ALL_PROFISSAO (state, value) {

        state.profissao = value

    },
    ALL_ESCOLARIDADE (state, value) {

        state.escolaridade = value

    },
    ALL_SEXO (state, value) {

        state.sexo = value

    },
    ALL_ESTADO_CIVIL (state, value) {

        state.estado_civil = value

    },
    ALL_PAIS (state, value) {

        state.pais = value

    },
    ALL_ESTADO_NATURALIDADE (state, value) {

        state.estado_naturalidade = value

    },
    ALL_CIDADE_NATURALIDADE (state, value) {

        state.cidade_naturalidade = value

    },
    ALL_ESTADO_ENDERECO (state, value) {

        state.estado_endereco = value

    },
    ALL_CIDADE_ENDERECO (state, value) {

        state.cidade_endereco = value

    },
   
}

export default mutations